export const initNewsEvents = () => {
  const allFilter = document.querySelector(
    '.dp-dfg-container .dp-dfg-filter:first-child .dp-dfg-filter-link',
  );
  const newsFilter = document.querySelector(
    '.dp-dfg-container .dp-dfg-filter:nth-child(2) .dp-dfg-filter-link',
  );
  const mediaMentionsFilter = document.querySelector(
    '.dp-dfg-container .dp-dfg-filter:last-child .dp-dfg-filter-link',
  );

  const currentHash = window.location.hash;
  const currentURL = window.location.href;
  const author = document.querySelector('.author');
  const published = document.querySelector('.published');

  if (allFilter) {
    allFilter.classList.remove('active');
  }

  if (newsFilter) {
    newsFilter.setAttribute('id', 'news');
  }

  if (mediaMentionsFilter) {
    mediaMentionsFilter.setAttribute('id', 'media-mentions');
  }

  if (currentHash === '#news') {
    newsFilter.classList.add('active');
  } else if (currentHash === '#media-mentions') {
    mediaMentionsFilter.classList.add('active');
  } else if (currentURL.includes('/news-events')) {
    if (allFilter) {
      allFilter.classList.add('active');
    }
  }

  if (window.location.href.includes('news-events')) {
    if (author) {
      author.style.display = 'none';
      published.classList.add('shift-date');
    }
  }
};
